import React from 'react'
import classnames from 'classnames'
import { debounce } from 'lodash'
import { __, sprintf } from 'StylistParent/i18n'

import Tooltip from 'Components/tooltip'
import Dropdown from 'Components/dropdown'
import CSSSelector from 'Components/css-selector'
import FullScreenToggle from 'Components/fullscreen-toggle'

import undoRedo from 'Functions/undo-redo'

/* Import CSS */
import './index.scss'

class Header extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			hasUndo: false,
			hasRedo: false,
		}
	}

	componentWillMount = () => {
		window.Stylist.updateHistory = debounce( () => {
			// Get undo/redo size from the CodeMirror editor.
			const undoSize = window.Stylist.codeEditor.getDoc().historySize().undo
			const redoSize = window.Stylist.codeEditor.getDoc().historySize().redo

			// Update component sate accordingly.
			if ( ! this.state.hasUndo && 0 < undoSize ) {
				this.setState( {
					hasUndo: true,
				} )
			} else if ( this.state.hasUndo && 0 === undoSize ) {
				this.setState( {
					hasUndo: false,
				} )
			}

			if ( ! this.state.hasRedo && 0 < redoSize ) {
				this.setState( {
					hasRedo: true,
				} )
			} else if ( this.state.hasRedo && 0 === redoSize ) {
				this.setState( {
					hasRedo: false,
				} )
			}
		}, 500 )
	}

	toggleInspector = () => {
		this.props.onInspectorToggle()
	}

	saveButtonLabel = () => {
		if ( this.props.isSaving ) {
			return __( 'Saving...' )
		} // Else:
		return __( 'Save' )
	}

	onCssSelectorChange = ( newSelector ) => {
		this.props.onCssSelectorChange( newSelector )
	}

	onPseudoClassChange = ( newPseudoClass ) => {
		this.props.onPseudoClassChange( newPseudoClass )
	}

	render() {
		const previewURL = window.stylistJsData.previewURL
		const closeURL = window.stylistJsData.closeURL
		const inspectorButtonClass = classnames(
			'stlst-selector-mode stlst-components-button stlst-components-icon-button', {
				active: this.props.inspectorActive,
			} )
		const responsiveModeButtonClass = classnames(
			'stlst-responsive-btn stlst-components-button stlst-components-icon-button', {
				active: this.props.responsiveView,
			} )

		return (
			<div className="stylist-header">
				<div className="stylist-header__primary">
					<p>{this.props.inspectorActive}</p>

					<Tooltip text="Select an element to style" position="bottom">
						<button type="button"
							aria-label="Element Inspector"
							onClick={this.toggleInspector}
							className={inspectorButtonClass}><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-select" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M17.9 9.9C17.4 9.9 16.9 9.5 16.9 8.9L16.9 4.2C16.9 3.6 16.4 3.1 15.8 3.1L4.2 3.1C3.6 3.1 3.1 3.6 3.1 4.2L3.1 15.8C3.1 16.4 3.6 16.9 4.2 16.9L8.9 16.9C9.5 16.9 9.9 17.4 9.9 17.9 9.9 18.5 9.5 19 8.9 19L4.2 19C2.4 19 1 17.6 1 15.8L1 4.2C1 2.4 2.4 1 4.2 1L15.8 1C17.6 1 19 2.4 19 4.2L19 8.9C19 9.5 18.5 9.9 17.9 9.9ZM9 9L19.7 12.6 16.6 14 19.7 16.8C20.1 17.2 20.1 17.9 19.7 18.3 19.5 18.5 19.2 18.6 18.9 18.6 18.7 18.6 18.4 18.5 18.2 18.3L15.2 15.5 13.8 19 9 9Z" /></svg></button>
					</Tooltip>

					<Tooltip text="Toggle responsive mode" position="bottom">
						<button type="button" aria-label="Responsive Mode"
							onClick={this.props.onResponsiveModeToggle}
							className={responsiveModeButtonClass}><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-redo" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M14.9 5.9C14.4 5.9 13.9 5.5 13.9 4.9L13.9 4.2C13.9 3.6 13.4 3.1 12.8 3.1L4.2 3.1C3.6 3.1 3.1 3.6 3.1 4.2L3.1 15.8C3.1 16.4 3.6 16.9 4.2 16.9L7.9 16.9C8.5 16.9 8.9 17.4 8.9 17.9 8.9 18.5 8.5 19 7.9 19L4.2 19C2.4 19 1 17.6 1 15.8L1 4.2C1 2.4 2.4 1 4.2 1L12.8 1C14.6 1 16 2.4 16 4.2L16 4.9C16 5.5 15.5 5.9 14.9 5.9ZM10 10C10 8.3 11.3 7 13 7L17 7C18.7 7 20 8.3 20 10L20 17C20 18.7 18.7 20 17 20L13 20C11.3 20 10 18.7 10 17L10 10ZM17 9L13 9C12.5 9 12 9.5 12 10L12 17C12 17.6 12.5 18 13 18L17 18C17.6 18 18 17.6 18 17L18 10C18 9.5 17.6 9 17 9Z" /><circle cx="15" cy="16" r="1" /></svg></button>
					</Tooltip>

					<Tooltip text="Undo" position="bottom">
						<button
							type="button"
							disabled={ ! this.state.hasUndo }
							onClick={ () => {
								undoRedo( 'undo' )
							} }
							aria-label="Undo"
							className="undo-btn stlst-components-button stlst-components-icon-button"><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-undo" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M12 5H7V2L1 6l6 4V7h5c2.2 0 4 1.8 4 4s-1.8 4-4 4H7v2h5c3.3 0 6-2.7 6-6s-2.7-6-6-6z"></path></svg></button>
					</Tooltip>

					<Tooltip text="Redo" position="bottom">
						<button type="button"
							disabled={ ! this.state.hasRedo }
							onClick={ () => {
								undoRedo( 'redo' )
							} }
							aria-label="Redo"
							className="redo-btn stlst-components-button stlst-components-icon-button"><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-redo" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M8 5h5V2l6 4-6 4V7H8c-2.2 0-4 1.8-4 4s1.8 4 4 4h5v2H8c-3.3 0-6-2.7-6-6s2.7-6 6-6z"></path></svg></button>
					</Tooltip>
				</div>

				<CSSSelector
					inspectorActive={this.props.inspectorActive}
					selectedEl={this.props.selectedEl}
					cssSelectorFull={this.props.cssSelectorFull}
					cssSelectorCustom={this.props.cssSelectorCustom}
					onCssSelectorChange = { this.onCssSelectorChange }
					onPseudoClassChange = { this.onPseudoClassChange } />

				<div className="stylist-header__secondary">
					<button type="button"
						className={ classnames(
							'stlst-save-btn stlst-components-button button button-primary button-large', {
								'is-saving': this.props.isSaving,
							} ) }
						disabled={ ! this.props.codeChanged }
						onClick={this.props.onSave}>{ this.saveButtonLabel() }</button>
					<Dropdown
						className="header-menu__toggle"
						contentClassName="header-menu__dropdown"
						position="bottom right"
						renderToggle={ ( { isOpen, onToggle } ) => (
							<div className="editor-mode-switcher"><button type="button" onClick={onToggle} aria-expanded={isOpen} aria-label="More" className="stlst-components-button stlst-components-icon-button"><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-ellipsis" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M5 10c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm12-2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg></button></div>
						)}
						renderContent={() => (
							<div>
								<a href={closeURL} className="wf-close-btn-link stlst-components-button stlst-components-icon-button"><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-admin-generic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M11.4 10L16.7 4.7C17.1 4.3 17.1 3.7 16.7 3.3 16.3 2.9 15.7 2.9 15.3 3.3L10 8.6 4.7 3.3C4.3 2.9 3.7 2.9 3.3 3.3 2.9 3.7 2.9 4.3 3.3 4.7L8.6 10 3.3 15.3C2.9 15.7 2.9 16.3 3.3 16.7 3.5 16.9 3.7 17 4 17 4.3 17 4.5 16.9 4.7 16.7L10 11.4 15.3 16.7C15.5 16.9 15.7 17 16 17 16.3 17 16.5 16.9 16.7 16.7 17.1 16.3 17.1 15.7 16.7 15.3L11.4 10 11.4 10Z" /></svg> { __( 'Close Style Editor' ) }</a>
								<FullScreenToggle />
							</div>
						) }
					/>
				</div>
			</div>
		)
	}
}

export default Header



// WEBPACK FOOTER //
// ./dev/stylist_parent/editor/header/index.jsx